export const navData = [
  { text: 'News', path: '/news' },
  { text: 'Find pet', path: `/notices/sell` },
  { text: 'Our friends', path: '/friends' },
];
